export const eur = (v, dec = 0) => {
  if (v == null || isNaN(v)) return "—";
  return "€ " + Number(v).toLocaleString("it-IT", { minimumFractionDigits: dec, maximumFractionDigits: dec });
};

export const pct = (v, dec = 1) => {
  if (v == null || isNaN(v)) return "—";
  return Number(v).toLocaleString("it-IT", { minimumFractionDigits: dec, maximumFractionDigits: dec }) + "%";
};

export const num = (v, dec = 0) => {
  if (v == null || isNaN(v)) return "—";
  return Number(v).toLocaleString("it-IT", { minimumFractionDigits: dec, maximumFractionDigits: dec });
};

export const dateIt = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

export const OCC_LABELS = {
  libero: "Libero",
  esecutato: "Occupato esecutato",
  terzi: "Terzi senza titolo",
  terzi_con_titolo: "Terzi con titolo",
};

export const STATE_COLORS = {
  Nuova: "#3B82F6",
  "In Analisi": "#D97706",
  Qualificata: "#10B981",
  "Contatto da effettuare": "#0EA5E9",
  "Contatto effettuato": "#8B5CF6",
  "Documentazione richiesta": "#EAB308",
  "In trattativa": "#F59E0B",
  "Due diligence": "#6366F1",
  Deliberata: "#22C55E",
  Acquistata: "#EA7B2B",
  Scartata: "#71717A",
};

export const scoreColor = (s) => {
  if (s >= 80) return "#10B981";
  if (s >= 60) return "#EA7B2B";
  if (s >= 40) return "#D97706";
  return "#71717A";
};

export const PRIORITY = {
  alta: { label: "Alta priorità", short: "Alta", color: "#E11D48", dot: "🔴" },
  media: { label: "Media priorità", short: "Media", color: "#F59E0B", dot: "🟠" },
  bassa: { label: "Bassa priorità", short: "Bassa", color: "#10B981", dot: "🟢" },
};

export const dateTimeIt = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};
